import React from "react";
import Link from "react-router-dom/Link";

export default function Popup({
  storeNumber,
  SKU_Count,
  annualSales,
  Avg_Weekly_Sales
}) {
  return (
    <div className="popup">
      <div className="popup__content">
        <div className="popup__header">
          <h1>Keep Tear Pads and Displays Visible</h1>
        </div>
        <div className="popup__body">
          <p>
            Tear pads let customers know what merchandise is typically carried
            in that store. Store <span className="red">{storeNumber}</span> has{" "}
            <span className="red">{SKU_Count}</span> items on the tear pad
            program and sells <span className="red">{Avg_Weekly_Sales}</span>{" "}
            worth of tear pad items each week for an annual total of{" "}
            <span className="red">{annualSales}</span>.
          </p>
        </div>

        <div className="popup__footer">
          <Link
            to={{
              pathname: "/solution/1",
              state: { prev: true }
            }}
            className="btn"
          >
            <span className="white-background">Replenish tear pads</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
